import React from 'react';

import { ContentBox, ContentsLayout, Main, Meta } from '@layout';
import { Examples, IntroTable, IntroText } from '@components';

import { Fade } from 'react-awesome-reveal';

const contents = {
  title1: '세금포인트 할인쇼핑몰 소개',
  title2: '세금포인트 할인쇼핑몰 소개',
  contentsHeaderTitle: '세금포인트 할인쇼핑몰 소개',
  contentsHeaderDesc: `<strong>세금포인트몰</strong>은 납세자가 보유하고 있는 <strong>세금포인트</strong>를 
사용하여 중소기업 제품을 <strong>할인</strong>받아<br/> 구매할 수 있는 <strong style='background: linear-gradient(transparent 65%, #c6e4f2 35%) no-repeat;'>세금포인트 사용 전용 온라인쇼핑몰</strong> 입니다.`,
  border: true,
};

const Index = () => {
  return (
    <Main
      meta={
        <Meta
          title="소개 | 세금포인트 할인쇼핑몰"
          description="세금포인트몰은 납세자가 보유하고 있는 세금포인트를 사용하여 중소기업 제품을 할인받아
구매할 수 있는 세금포인트 사용 전용 온라인쇼핑몰 입니다."
          canonical='https://www.taxpoint.or.kr'
        />
      }
    >
      <ContentsLayout contents={contents}>
        <div className="flex flex-col">
          <Fade triggerOnce cascade>
            <ContentBox title="세금포인트 제도">
              <IntroText />
            </ContentBox>
            <ContentBox title="구매금액별 사용포인트 및 할인율">
              <IntroTable />
            </ContentBox>
            <ContentBox title="세금포인트 사용 할인방법 예시">
              <Examples />
            </ContentBox>
          </Fade>
        </div>
      </ContentsLayout>
    </Main>
  );
};

export default Index;
